module.exports = __webpack_public_path__ + "f9b683853a2e628c32402e15bb85ca3f.svg";